import React from 'react';
import { connect } from 'react-redux';
import {
  RouteComponentProps, useHistory, withRouter,
} from 'react-router-dom';
import { ResourcesItem } from 'redux-and-the-rest';
import { IslandModel } from '../../models/islandModel';
import { getOrFetchIsland } from '../../redux/reducers/islandReducer';
import { ApplicationState } from '../../redux/types';
import { Routes } from '../../routes';
import ModalWrapper from '../modals/ModalWrapper';
import AddEditIsland from './manage-islands-wizard/AddEditIsland';

interface Props {
  island: ResourcesItem<IslandModel>
}

const EditIslandModal = ({ island }: Props): React.ReactElement => {
  const history = useHistory();

  const onClose = () => {
    history.push(Routes.Islands.Index);
  };

  return (
    <ModalWrapper onClose={onClose} headerTitle="Save My Island">
      <AddEditIsland
        island={island}
        onCancel={onClose}
        onComplete={onClose}
      />
    </ModalWrapper>
  );
};

const mapStateToProps = (
  { islands }: ApplicationState,
  { match: { params: { id } } }: RouteComponentProps<{ id: string; }>,
) => ({
  island: getOrFetchIsland(islands, { id }),
});

export default withRouter(connect(mapStateToProps)(EditIslandModal));
